import { Button, type ButtonProps } from '@e2n/ui/v2';
import {
  faSpinnerThird,
  type IconDefinition,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useFormContext } from '../hooks';

type SubmitButtonProps = {
  buttonText: string;

  leadingIcon?: IconDefinition;
} & ButtonProps;

export function SubmitButton({
  buttonText,
  variant = 'primary-pill',
  size,
  leadingIcon,
  disabled,
  ...rest
}: SubmitButtonProps) {
  const form = useFormContext();
  const { t } = useTranslation();
  return (
    <form.Subscribe
      selector={(state) => [
        state.isSubmitting,
        state.canSubmit,
        state.isValid,
        state.isTouched,
      ]}>
      {([isSubmitting, canSubmit, isValid]) => {
        const buttonContent = isSubmitting ? (
          <>
            <FontAwesomeIcon icon={faSpinnerThird} spin />
            {t('actions.loading')}
          </>
        ) : (
          <>
            {leadingIcon && (
              <FontAwesomeIcon icon={leadingIcon} className="mr-2" />
            )}
            {buttonText}
          </>
        );

        return (
          <Button
            variant={variant}
            type="submit"
            size={size}
            disabled={isSubmitting || !canSubmit || !isValid || disabled}
            className="gap-2"
            {...rest}>
            {buttonContent}
          </Button>
        );
      }}
    </form.Subscribe>
  );
}
